// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"0cdef93a","668":"b4df2aa4","787":"7e834572"}[chunkId] + ".chunk.js";
};